<template>
    <div class="centered"  v-if="!slides.length">
        <img src="img/carrusel_default.png" alt="SEDATU" class="centered__imgDefault" id="carrusel_inicio">
    </div>
    <div class="centered" v-else>
        <vueper-slides 
                ref="myVueperSlides"
                autoplay
                :pause-on-hover="pauseOnHover"
                @autoplay-pause="internalAutoPlaying = false"
                @autoplay-resume="internalAutoPlaying = true"
                class="centered__carrusel"
                :fixed-height="true">

            <vueper-slide
                    v-for="(slide, i) in slides"
                    :key="i"
                    :title="slide.tituloImg"
                    :content="slide.descripcionImg"
                    :image="slide.imagenBase64"/>
        </vueper-slides>
    </div>
</template>

<script>

    import axios from 'axios';
    import { VueperSlides, VueperSlide } from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'
    import Vue from 'vue';

    export default {
        name: "Slider.vue",
        components: { VueperSlides, VueperSlide },
        data: () => ({
            pauseOnHover: true,
            autoPlaying: true,
            internalAutoPlaying: true,
            slides: []
        }),
        mounted() {

            axios.post(Vue.prototype.$globalHost + '/consultaImagenesHabilitadasCarrusel',
            {}, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                this.slides = response.data;
            })
            .catch(error => {
                console.log(error);
            })

        }
    }
</script>

<style scoped>

    .centered {
        height: 100%;
        display: grid;
        grid-template-rows: 15% 3fr 15%
    }

    .centered__imgDefault {
        grid-row-start: 2;
        width: 100%;
        height: 400px;
        object-fit: cover;
        object-fit: scale-down;
    }

    .centered__carrusel {
        grid-row-start: 2;
    }

    .vueperslides--fixed-height { 
        height: 400px; 
    }

    @media screen and (min-width: 760px) and (max-width: 812px){
        .centered__imgDefault, .vueperslides--fixed-height {
            height: 370px;
        }
    }

    @media screen and (min-width: 715px) and (max-width: 759px){
        .centered__imgDefault, .vueperslides--fixed-height {
            height: 340px;
        }
    }

    @media screen and (min-width: 680px) and (max-width: 714px){
        .centered__imgDefault, .vueperslides--fixed-height {
            height: 310px;
        }
    }

    @media screen and (min-width: 630px) and (max-width: 679px){
        .centered__imgDefault, .vueperslides--fixed-height {
            height: 280px;
        }
    }

    @media screen and (min-width: 600px) and (max-width: 629px){
        .centered__imgDefault, .vueperslides--fixed-height {
            height: 250px;
        }
    }

    @media screen and (min-width: 569px) and (max-width: 599px){
        .centered__imgDefault, .vueperslides__parallax-wrapper {
            height: 220px;
        }
    }

</style>
